import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f94a888")

_pushScopeId("data-v-0f94a888")
const _hoisted_1 = { class: "icon-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")
  const _component_ion_tabs = _resolveComponent("ion-tabs")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_tabs, { id: "tabs" }, {
        default: _withId(() => [
          _createVNode(_component_ion_tab_bar, { slot: "bottom" }, {
            default: _withId(() => [
              _createVNode(_component_ion_tab_button, {
                tab: "timeline",
                href: "/timeline"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.grid }, null, 8, ["icon"]),
                  _createVNode(_component_ion_label, null, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trTabs, 'timeline')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "shop",
                href: "/product",
                disabled: true
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode(_component_ion_icon, {
                      class: "custom-icon",
                      src: "/assets/icon/logo-gold.svg"
                    }),
                    _createVNode(_component_ion_icon, {
                      class: "custom-icon active",
                      src: "/assets/icon/lazylogo.svg"
                    })
                  ]),
                  _createVNode(_component_ion_label, { class: "custom-label" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trTabs, 'shop')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})